import calculateThumborUrl from 'helpers/calculateThumborUrl'

export const API_HOST = process.env.API_HOST || ''
export const MAILTO = '?subject=:subject&body=:body'

export const URL_ABOUT = '/team.json'
export const URL_ASSOCIATED_RESOURCE_ENTRY = 'secure/associated-resource/:urn/qa-annotation'
export const URL_ASSOCIATED_RESOURCE_QUERY = 'secure/associated-resource/query/:qualifier/:urn'
export const URL_ASSOCIATED_RESOURCE_UPSERT = 'secure/associated-resource/upsert'
export const URL_CRYPTO_KEY_LIST = 'secure/keymgmt/api/keymgmt/serve/ceku'
export const URL_CRYPTO_KEY_ADD = 'secure/keymgmt/api/keymgmt/manage/ceku'
export const URL_CURRENT_AWARENESS = 'secure/api/:aol/service/ca/browse/:fromDate/:toDate'
export const URL_CURRENT_AWARENESS_PREPAY = 'api/:aol/service/ca/browse/:fromDate/:toDate'
export const URL_CURRENT_AWARENESS_HOMEPAGE = 'api/:aol/service/ca/homepage-articles'
export const URL_CURRENT_AWARENESS_HOMEPAGE_ARTICLE = 'secure/api/:aol/service/ca/homepage-article/id/:id'
export const URL_CURRENT_AWARENESS_HOMEPAGE_ARTICLE_PREPAY = 'api/:aol/service/ca/homepage-article/id/:id'
export const URL_CURRENT_AWARENESS_SEARCH = 'secure/api/:aol/service/ca/search/(browse/:fromDate/:toDate)(:search)'
export const URL_CURRENT_AWARENESS_SEARCH_PREPAY = 'api/:aol/service/ca/search/(browse/:fromDate/:toDate)(:search)' // to not send a date you have to set search='search'
export const URL_CURRENT_AWARENESS_ARTICLE = 'secure/api/:aol/service/ca/browse/id/:id'
export const URL_DATA = 'secure/api/:aol/precedents/service/data/:id'
export const URL_DOCUMENT = 'secure/api/:aol/precedents/service/document(/:id)'
export const URL_FEEDBACK = 'secure/api/service/feedback'
export const URL_GUIDE = 'static/:fileName'
export const URL_SECURE_GUIDE = 'secure/static/:fileName'
export const URL_GUIDES = 'static-content/api/folders'
export const URL_FEATURED_GUIDES = 'static-content/api/featured'
export const URL_PUBLISHED_CA_KEY_PICKS = '/secure/api/:aol/service/ca/key-picks'
export const URL_CA_KEY_PICK_ARTICLE = ':aol/ca/id/:id'
export const URL_LEGISLATION_ACT = 'secure/api/:aol/leg/:act'
export const URL_LEGISLATION_ACTS = 'api/:aol/leg/list?complete=true'
export const URL_LEGISLATION_FOLDERS = 'api/:aol/leg/folders?complete=true'
export const URL_LEGISLATION_CHAPTER = 'secure/api/service/legislation/chapter/:section/:chapter/:act(/:schedule)'
export const URL_LEGISLATION_PART = 'secure/api/service/legislation/part/:part/:act(/:schedule)'
export const URL_LEGISLATION_REFERENCE = 'secure/api/:aol/leg/:references'
export const URL_LEGISLATION_RELATED_QAS = 'secure/api/service/legislation/referenceqa/:flavour/(schedule-:schedule-)(part-:part-)(section-:section)/1/100'
export const URL_LEGISLATION_SCHEDULE = 'secure/api/service/legislation/schedule/:schedule/:act'
export const URL_LEGISLATION_SEARCH = 'secure/api/:aol/service/legsearch' // '/:queryString/:init/:limit'
export const URL_LEGISLATION_SEARCH_PREPAY = 'api/:aol/service/legsearch'
export const URL_LEGISLATION_SECTION = 'secure/api/service/legislation/section/:section/:act(/:schedule)'
export const URL_LEGISLATION_TOC = 'secure/api/service/legislation/toc/:act'
export const URL_LOGOUT = '/secure/api/auth/logout'
export const URL_METADATA = 'secure/api/:aol/precedents/service/document(/:id)'
export const URL_METADATA_GET_LIST = 'secure/api/:aol/precedents/search/metadata'
export const URL_METADATA_GET_LIST_PREPAY = 'api/:aol/precedents/search/metadata'
export const URL_METADATA_SEARCH = 'secure/api/:aol/precedents/search/metadata'
export const URL_METADATA_SECTIONS = '/secure/api/:aol/service/sections/documents'
export const URL_METADATA_SECTIONS_PREPAY = '/api/:aol/service/sections/documents'
export const URL_PASSWORD_RESET = 'secure/users-api/users/client-password-reset'
export const URL_PDF = 'secure/api/pdfservice'
export const URL_PDF_CA = 'secure/api/:aol/ca/pdf/:short'
export const URL_PDF_LEG = 'secure/api/:aol/leg/pdf/:short'
export const URL_PDF_QA = 'secure/api/:aol/qa/pdf/:short'
export const URL_PRINT = 'secure/api/prettyprint(/:short)'
export const URL_QA_CONTENT = 'secure/api/:aol/service/questions/:flavour/:sections'
export const URL_QA_CONTENT_PREPAY = 'api/:aol/service/questions/:flavour/:sections'
export const URL_QA_INSTANTSEARCH = 'secure/api/service/autocomplete/:flavour/:queryString/0/10'
export const URL_QA_QUESTIONS = 'secure/api/:aol/service/questions/:flavour'
export const URL_QA_QUESTIONS_PREPAY = 'api/:aol/service/questions/:flavour'
export const URL_QA_REFERENCES = 'secure/api/:aol/service/listQuestions/:references'
export const URL_QA_SEARCH = 'secure/api/:aol/service/search/:flavour'
export const URL_QA_SEARCH_PREPAY = 'api/:aol/service/search/:flavour'
export const URL_QA_SECTIONS = 'secure/api/:aol/service/sections/:flavour'
export const URL_QA_SECTIONS_PREPAY = 'api/:aol/service/sections/:flavour'
export const URL_SEARCH_HISTORY = 'secure/api/service/search-history(/:length)'
export const URL_SHORTENER = 'secure/shorty/api/resource(/:short)'
export const URL_TAKEOVER_CODE = 'secure/takeover/code(/:versionId)'
export const URL_TAKEOVER_CODE_VERSIONS = 'secure/takeover/codes'
export const URL_TAKEOVER_CODE_COPY = 'secure/takeover/copy'
export const URL_TAKEOVER_CODE_PUBLISH = 'secure/takeover/version'
export const URL_TAKEOVER_CODE_EDIT_TITLE = 'secure/takeover/section'
export const URL_TAKEOVER_CODE_EDIT_PARAGRAPH = 'secure/takeover/paragraph'
export const URL_TAKEOVER_CODE_DELETE_PARAGRAPH = 'secure/takeover/paragraph/:paragraphId'
export const URL_TAKEOVER_CODE_CREATE_PARAGRAPH = 'secure/takeover/paragraph'
export const URL_TAKEOVER_CODE_EDIT_PREFIX = 'secure/takeover/textPrefix'
export const URL_TAKEOVER_CODE_DELETE_PREFIX = 'secure/takeover/textPrefix/:textPrefixId'
export const URL_TAKEOVER_CODE_CREATE_PREFIX = 'secure/takeover/textPrefix'
export const URL_TRACKING = 'secure/api/service/tracking'
export const URL_USER = 'secure/api/auth/current-user'
export const URL_USERS = 'secure/associated-resource/users'
export const URL_EMAIL_PREFERENCES = 'secure/users-api/customer/email-preferences'
export const URL_USER_AUTH = 'secure/api/auth/external-auth'
export const URL_WRAPPING_CRYPTO_KEY = 'secure/keymgmt/api/keymgmt/serve/ckek' // 'rsa.jwk'
export const URL_GENERATE_WRAPPING_KEY = 'secure/keymgmt/api/keymgmt/manage/ckek'
export const URL_IDP_LOGIN = '/gw/'
export const TAKEOVER_INTERNAL = 'TAKEOVER+CODE'
export const URL_CLARILIS_LINK = 'secure/api/user/clarilis-link'
export const URL_CLARILIS_LINK_PREPAY = 'api/user/clarilis-link'
export const URL_CLARILIS_DOCS = 'secure/api/user/doc-auto-suites'
export const URL_CLARILIS_DOCS_PREPAY = 'api/user/doc-auto-suites'
export const URL_DOC_DRAFTER_AUTOMATED_LIST = 'secure/api/:aol/docs/templates/automated'
export const URL_DOC_DRAFTER_AUTOMATED_LIST_PREPAY = 'api/:aol/docs/templates/automated'
export const URL_DOC_DRAFTER_SAVED_DOCUMENTS = 'secure/api/:aol/docs/sso/saved-documents'
export const URL_DOC_DRAFTER_DOCUMENT_INTERVIEW = 'secure/api/:aol/docs/sso/template/:uuid'
export const URL_THUMBOR = calculateThumborUrl // calculating this is work so i moved it to its own file
export const URL_MW_EVENT_TYPES = 'api/mw-config/configuration/marketevent/type'
export const URL_MW_FEATURED_DEAL = 'mw-analytics/api/events/featured'
export const URL_MW_STATS_SUMMARY = 'mw-analytics/api/stats/summary'
export const URL_MW_LATEST_DEALS = 'mw-analytics/api/events/latest'
export const URL_MW_EVENT_CONFIGURATION = 'api/mw-config/configuration/marketevent/:type'
export const URL_MW_SHARED_EVENTS_CONFIGURATION = 'api/mw-config/configuration/marketevent/parametergroup'
export const URL_MW_LIST_DEALS = 'mw-analytics/api/events'
export const URL_MW_STATS = 'secure/mw-analytics/api/stats'
export const URL_MW_DEAL = 'secure/mw-analytics/api/events/:dealId'
export const URL_MW_DEAL_DOCUMENT = 'secure/mw-analytics/api/events/:dealId/download/:docId'
export const URL_DOWNLOAD_DEAL_PDF = 'secure/mw-analytics/api/events/:dealId/pdf'
export const URL_DOWNLOAD_DEAL_ZIP = 'secure/mw-analytics/api/events/:dealId/download'
export const URL_DOWNLOAD_DEAL_EXCEL = 'secure/mw-analytics/api/events/:dealId/excel'
export const URL_DOWNLOAD_DEAL_COMPARISON_EXCEL = 'secure/mw-analytics/api/events/compare?events=:deals&parameterName=:parameters'
export const URL_MW_SCOPE_OF_SERVICE = 'secure/mw-analytics/api/documentation'
export const URL_INTERVIEW_TEMPLATES = 'api/:aol/docs/templates'
export const URL_STATIC_DOCUMENTS = 'api/:aol/docs/static-docs'
export const URL_INTERVIEW = 'secure/api/:aol/docs/questionnaires/:interviewId'
export const URL_SUBMIT_INTERVIEW = 'secure/api/:aol/docs/questionnaires/live/:guid'
export const URL_INTERVIEW_PREVIEW = 'secure/api/:aol/docs/questionnaires/live/:guid/previews/:fileId'
export const URL_PREVIEW_LIST = 'secure/api/:aol/docs/questionnaires/live/:guid/previews'
export const URL_DOWNLOAD_INTERVIEW = 'secure/api/:aol/docs/questionnaires/live/:guid/documents'
export const URL_INTERVIEW_METADATA = '/api/:aol/docs/templates/automated/:interviewId'
export const URL_SAVED_INTERVIEW = 'secure/api/:aol/docs/questionnaires/questionnaire-from-doc/:saveId'
export const URL_USER_UPSERT = 'secure/users-api/users'
export const URL_ACCESS_ROLES = 'secure/users-api/access-roles'
